'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _axiosRetry = require('axios-retry');

var _axiosRetry2 = _interopRequireDefault(_axiosRetry);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_IMAGE = 'https://ri.dyzio.co/no_image_available.png';

var restClient = _axios2.default.create({
  timeout: 5000
});

(0, _axiosRetry2.default)(restClient, {
  delay: 100,
  retries: 3
});

var thumbnailStyle = {
  width: '100%',
  objectFit: 'cover',
  display: 'table-cell',
  verticalAlign: 'middle',
  backgroundColor: '#EEEEEE'
};

var noImageStyle = {
  width: '60%',
  objectFit: 'cover',
  display: 'table-cell',
  verticalAlign: 'middle',
  backgroundColor: '#EEEEEE'
};

var DyzioInstagramThumbnail = function (_React$Component) {
  (0, _inherits3.default)(DyzioInstagramThumbnail, _React$Component);

  function DyzioInstagramThumbnail() {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, DyzioInstagramThumbnail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DyzioInstagramThumbnail.__proto__ || (0, _getPrototypeOf2.default)(DyzioInstagramThumbnail)).call(this));

    _this.loadEmbed = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('skip embed');
              // const shortCode = this.props.assetId;
              // const baseUrl = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/';
              // const path = `influencer/instagram/embed/${shortCode}`;
              // restClient.get(`${baseUrl}${path}`).then(response => {
              //   const embed = response.data;
              //   this.setState({
              //     imageUrl: embed.body.data.thumbnail_url,
              //     requestFinished: true,
              //   });
              // }).catch(err => {
              //   console.log('err', err);
              //   this.setState({
              //     imageUrl: '',
              //     requestFinished: true,
              //   });
              // });

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.state = {
      imageUrl: '',
      requestFinished: false,
      initialised: false
    };
    return _this;
  }

  (0, _createClass3.default)(DyzioInstagramThumbnail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.trackedAssetId) {
        var initialised = this.state.initialised;

        if (!initialised) {
          this.loadEmbed();
        }
        this.setState({
          initialised: true
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!this.props.trackedAssetId) {
        if (this.props.assetId !== prevProps.assetId) {
          this.loadEmbed();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      // const { imageUrl, requestFinished } = this.state;
      var _props = this.props,
          customStyle = _props.customStyle,
          fallbackURL = _props.fallbackURL,
          assetId = _props.assetId,
          savedMediumImageUrl = _props.savedMediumImageUrl;


      var style = (0, _extends3.default)({}, thumbnailStyle, customStyle);

      if (assetId) {
        return _react2.default.createElement(_semanticUiReact.Image, {
          style: style,
          src: 'https://pics.dyzio.co/' + assetId + '.jpg',
          onError: function onError(i) {
            i.target.src = DEFAULT_IMAGE;
          }
        });
      }

      if (savedMediumImageUrl) {
        return _react2.default.createElement(_semanticUiReact.Image, {
          style: style,
          src: savedMediumImageUrl,
          onError: function onError(i) {
            i.target.src = DEFAULT_IMAGE;
          }
        });
      }

      return _react2.default.createElement(_semanticUiReact.Image, {
        style: style,
        src: fallbackURL,
        onError: function onError(i) {
          i.target.src = DEFAULT_IMAGE;
        }
      });
    }
  }]);
  return DyzioInstagramThumbnail;
}(_react2.default.Component);

DyzioInstagramThumbnail.propTypes = {
  assetId: _propTypes2.default.string.isRequired,
  customStyle: _propTypes2.default.object,
  fallbackURL: _propTypes2.default.string,
  trackedAssetId: _propTypes2.default.string,
  savedMediumImageUrl: _propTypes2.default.string
};

DyzioInstagramThumbnail.defaultProps = {
  customStyle: {},
  fallbackURL: '',
  trackedAssetId: null,
  savedMediumImageUrl: null
};

exports.default = DyzioInstagramThumbnail;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/dyzio-instagram-thumbnail/index.js
 ** module id = 2573
 ** module chunks = 0
 **/